module.exports = __webpack_public_path__ + "static/client_12_after-a4948ef45b022ad6bef7e09b19047e03.jpg";